(function(){
  function money(cents){
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(cents/100)}catch(e){return '$'+(cents/100).toFixed(2)}
  }

  const cartDrawer=document.querySelector('[data-cart-drawer]');
  const accountDrawer=document.querySelector('[data-account-drawer]');

  function openDrawer(el){if(!el)return;el.classList.add('open');el.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'}
  function closeDrawer(el){if(!el)return;el.classList.remove('open');el.setAttribute('aria-hidden','true');document.body.style.overflow=''}

  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-open]')){e.preventDefault();refreshCart().then(()=>openDrawer(cartDrawer));}
    if(e.target.closest('[data-cart-close]'))closeDrawer(cartDrawer);
    if(e.target.closest('[data-account-open]')){e.preventDefault();openDrawer(accountDrawer);}
    if(e.target.closest('[data-account-close]'))closeDrawer(accountDrawer);
    if(e.target===cartDrawer)closeDrawer(cartDrawer);
    if(e.target===accountDrawer)closeDrawer(accountDrawer);
    const remove=e.target.closest('[data-cart-remove]');
    if(remove){e.preventDefault();changeCart(remove.dataset.cartRemove,0);}
  });

  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeDrawer(cartDrawer);closeDrawer(accountDrawer)}});

  async function refreshCart(){
    const res=await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart.js',{headers:{Accept:'application/json'}});
    const cart=await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    const items=document.querySelector('[data-cart-items]');
    const total=document.querySelector('[data-cart-total]');
    if(total)total.textContent=money(cart.total_price);
    if(items){
      if(!cart.items.length){items.innerHTML='<p class="drawer-muted">Your cart is empty.</p>';}
      else{items.innerHTML=cart.items.map(item=>`<div class="drawer-item"><a class="drawer-thumb" href="${item.url}">${item.image?`<img src="${item.image}" alt="">`:'Q'}</a><div><strong>${item.product_title}</strong><span>Qty ${item.quantity}${item.variant_title&&item.variant_title!=='Default Title'?` · ${item.variant_title}`:''}</span><br><button class="drawer-remove" data-cart-remove="${item.key}" type="button">Remove</button></div><span class="drawer-price">${money(item.final_line_price)}</span></div>`).join('');}
    }
    return cart;
  }

  async function changeCart(key,quantity){
    await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
    await refreshCart();
  }

  document.querySelectorAll('.product-form').forEach(form=>{
    form.addEventListener('submit',async function(e){
      e.preventDefault();
      const button=form.querySelector('[data-add-to-cart]');
      if(button&&button.disabled)return;
      const original=button?button.textContent:'';
      if(button){button.disabled=true;button.textContent='Adding…';}
      try{
        const response=await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        if(!response.ok)throw new Error('Unable to add item');
        await refreshCart();
        openDrawer(cartDrawer);
      }catch(err){alert(err.message||'Unable to add this item to the cart.');}
      finally{if(button){button.disabled=false;button.textContent=original;}}
    });
  });

  document.querySelectorAll('[data-product-root]').forEach(root=>{
    const variantsEl=root.querySelector('[data-product-json]');
    if(!variantsEl)return;
    let variants=[];
    try{variants=JSON.parse(variantsEl.textContent)}catch(e){return}
    const groups=[...root.querySelectorAll('[data-option-group]')];
    const idInput=root.querySelector('[data-variant-id]');
    const price=root.querySelector('[data-product-price]');
    const stock=root.querySelector('[data-product-stock]');
    const sku=root.querySelector('[data-product-sku]');
    const add=root.querySelector('[data-add-to-cart]');

    function updateVariant(){
      const selected=groups.map(g=>{const active=g.querySelector('.chip.active');return active?active.dataset.optionValue:null});
      const variant=variants.find(v=>selected.every((value,index)=>value===null||v.options[index]===value));
      if(!variant)return;
      if(idInput)idInput.value=variant.id;
      if(price)price.textContent=money(variant.price);
      if(stock)stock.textContent=variant.available?'In stock':'Sold out';
      if(sku)sku.textContent=variant.sku||variant.id;
      if(add){add.disabled=!variant.available;add.textContent=variant.available?'Add to cart':'Sold out';}
      if(history.replaceState){const u=new URL(location.href);u.searchParams.set('variant',variant.id);history.replaceState({},'',u.toString());}
    }

    groups.forEach(group=>group.addEventListener('click',e=>{const chip=e.target.closest('.chip');if(!chip)return;group.querySelectorAll('.chip').forEach(c=>c.classList.remove('active'));chip.classList.add('active');updateVariant();}));
    const minus=root.querySelector('[data-qty-minus]'),plus=root.querySelector('[data-qty-plus]'),qty=root.querySelector('[data-qty-input]');
    if(minus&&qty)minus.addEventListener('click',()=>qty.value=Math.max(1,Number(qty.value||1)-1));
    if(plus&&qty)plus.addEventListener('click',()=>qty.value=Math.max(1,Number(qty.value||1)+1));
    root.querySelectorAll('[data-gallery-thumb]').forEach(btn=>btn.addEventListener('click',()=>{const img=root.querySelector('[data-product-main-image] img');if(img){img.src=btn.dataset.imageSrc;img.removeAttribute('srcset');}root.querySelectorAll('[data-gallery-thumb]').forEach(b=>b.classList.remove('active'));btn.classList.add('active');}));
  });


  document.addEventListener('click',function(e){
    const link=e.target.closest('[data-product-preview-link]');
    if(!link)return;
    const handle=link.dataset.productPreviewLink;
    const shell=link.closest('.product-card-shell');
    const dataEl=shell&&shell.querySelector('[data-product-preview-json]');
    if(!handle||!dataEl)return;
    try{sessionStorage.setItem('quipt-product-preview:'+handle,dataEl.textContent.trim());}catch(err){}
  });

  function initDraftProductPreview(){
    const root=document.querySelector('[data-draft-product-preview]');
    if(!root)return;
    const handle=decodeURIComponent((location.hash||'').replace(/^#/,''));
    let raw=null;
    try{raw=sessionStorage.getItem('quipt-product-preview:'+handle)}catch(err){}
    const missing=root.querySelector('[data-preview-missing]');
    const content=root.querySelector('[data-preview-content]');
    if(!raw){if(missing)missing.hidden=false;return;}

    let product;
    try{product=JSON.parse(raw)}catch(err){if(missing)missing.hidden=false;return;}
    if(content)content.hidden=false;

    const setText=(sel,value)=>{const el=root.querySelector(sel);if(el)el.textContent=value||''};
    setText('[data-preview-breadcrumb]',product.title);
    setText('[data-preview-title]',product.title);
    setText('[data-preview-kicker]',product.vendor||product.type||'');
    setText('[data-preview-price]',money(product.price||0));
    setText('[data-preview-stock]',product.available?'In stock':'Not currently available');

    const desc=root.querySelector('[data-preview-description]');
    const descCopy=root.querySelector('[data-preview-description-copy]');
    const description=product.description||'<p>Product information will appear here when a description is added in Shopify.</p>';
    if(desc)desc.innerHTML=description;
    if(descCopy)descCopy.innerHTML=description;

    const main=root.querySelector('[data-preview-main-image]');
    if(main&&product.featured_image){main.innerHTML=`<img src="${product.featured_image}" alt="">`;}

    const thumbs=root.querySelector('[data-preview-thumbs]');
    if(thumbs&&Array.isArray(product.images)&&product.images.length>1){
      thumbs.innerHTML=product.images.slice(0,6).map((src,index)=>`<button type="button" class="gallery-thumb${index===0?' active':''}" data-preview-thumb="${src}"><img src="${src}" alt=""></button>`).join('');
      thumbs.addEventListener('click',e=>{const btn=e.target.closest('[data-preview-thumb]');if(!btn||!main)return;main.innerHTML=`<img src="${btn.dataset.previewThumb}" alt="">`;thumbs.querySelectorAll('.gallery-thumb').forEach(b=>b.classList.remove('active'));btn.classList.add('active');});
    }

    const variants=Array.isArray(product.variants)?product.variants:[];
    let selected=variants[0]||null;
    const optionsWrap=root.querySelector('[data-preview-options]');
    const optionNames=Array.isArray(product.options)?product.options:[];
    if(optionsWrap&&variants.length>1&&optionNames.length){
      const groups=optionNames.map((name,index)=>{
        const values=[...new Set(variants.map(v=>v.options&&v.options[index]).filter(Boolean))];
        return `<div class="option-group" data-preview-option-group="${index}"><span class="option-label">${name}</span><div class="chips">${values.map((value,i)=>`<button class="chip${i===0?' active':''}" type="button" data-preview-option-value="${String(value).replace(/"/g,'&quot;')}">${value}</button>`).join('')}</div></div>`;
      }).join('');
      optionsWrap.innerHTML=groups;
      const update=()=>{
        const values=[...optionsWrap.querySelectorAll('[data-preview-option-group]')].map(group=>{const active=group.querySelector('.chip.active');return active&&active.dataset.previewOptionValue;});
        selected=variants.find(v=>values.every((value,index)=>!value||(v.options&&v.options[index]===value)))||variants[0]||null;
        if(selected){setText('[data-preview-price]',money(selected.price||product.price||0));setText('[data-preview-stock]',selected.available?'In stock':'Sold out');setText('[data-preview-sku]',selected.sku||selected.id||'—');}
      };
      optionsWrap.addEventListener('click',e=>{const chip=e.target.closest('.chip');if(!chip)return;const group=chip.closest('[data-preview-option-group]');group.querySelectorAll('.chip').forEach(c=>c.classList.remove('active'));chip.classList.add('active');update();});
      update();
    }else if(selected){setText('[data-preview-sku]',selected.sku||selected.id||'—');}
  }

  initDraftProductPreview();
})();
